import store from "@/store/index";

export interface AppCoachPlayersCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    from: number;
    to: number;
  };
}

export class AppCoachPlayersCategoriesListFormCreate implements AppCoachPlayersCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    from: number;
    to: number;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      from: null,
      to: null,
    };
  }
}